import { round } from 'lodash'
import { Column, ProgressBar, Row, Text } from '@/components/core'
import { classNameBuilder } from '@/helpers'

type FluencyResultProps = {
  fluencyScore: number
  isResponsive?: boolean
}

const FluencyResult = ({
  fluencyScore,
  isResponsive = true
}: FluencyResultProps) => {
  return (
    <Row
      className={classNameBuilder(
        '!mb-4 mt-6 w-full flex-row flex-wrap space-y-1',
        isResponsive && 'max-lg:px-8'
      )}
    >
      <Row
        className={classNameBuilder(
          'w-full items-center justify-between',
          isResponsive && 'lg:w-2/5'
        )}
      >
        <Text.Translated
          size="lg"
          className="w-30 justify-center self-start text-[#353535] max-lg:hidden"
          fontWeight="bold"
          translationKey="fluency_title_analysis_card"
        />
        <Text.Translated
          size="md"
          className="w-30 justify-center self-start text-[#353535] lg:hidden"
          fontWeight="bold"
          translationKey="fluency_title_mobile_analysis_card"
        />
        <Text size="xs" fontWeight="bold" className="!text-electric-indigo-500">
          {round(fluencyScore / 10, 1)} / 10
        </Text>
      </Row>
      <Row className="w-full">
        <Column
          className={classNameBuilder(
            'relative h-3 w-full overflow-hidden rounded-lg bg-[#D9D9D9]/50',
            isResponsive && 'lg:w-2/5'
          )}
        >
          <ProgressBar
            className={{
              wrapper: 'h-3 w-full bg-[#E0E0E0]',
              divider: false,
              bar: 'rounded-lg bg-gradient-to-r from-[#09D4E1] to-[#6A0DFD]'
            }}
            progress={fluencyScore / 100}
          />
        </Column>
      </Row>
    </Row>
  )
}

export default FluencyResult
